import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, MapPin, UploadCloud, CheckCircle2, Camera } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { ProgressBar } from '../../components/ui/ProgressBar';
import { useScreenInit } from '../../useScreenInit';
export function BeneficiaryOnboarding() {
  const screenInit = useScreenInit();
  const navigate = useNavigate();
  const [step, setStep] = useState(screenInit.step ?? 1);
  const totalSteps = 11; // Excluding success screen
  const handleNext = () => {
    if (step <= totalSteps) {
      setStep(step + 1);
    }
  };
  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    } else {
      navigate(-1);
    }
  };
  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <div className="space-y-5" data-id="element-318">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-319">
              Personal Information
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-320">
              Let's start with your basic details.
            </p>

            <div data-id="element-321">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-322">
                Full Name (as on ID)
              </label>
              <input type="text" placeholder="e.g. Amina Diallo" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-323" />
            </div>
            <div data-id="element-324">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-325">
                Date of Birth
              </label>
              <input type="date" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-326" />
            </div>
            <div data-id="element-327">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-328">
                Gender
              </label>
              <select className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-329">
                <option data-id="element-330">Select Gender</option>
                <option data-id="element-331">Female</option>
                <option data-id="element-332">Male</option>
                <option data-id="element-333">Other</option>
              </select>
            </div>
          </div>;
      case 2:
        return <div className="space-y-5" data-id="element-334">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-335">
              Contact Information
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-336">
              How can we reach you?
            </p>

            <div data-id="element-337">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-338">
                Primary Phone Number
              </label>
              <input type="tel" placeholder="+234" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-339" />
            </div>
            <div data-id="element-340">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-341">
                Alternative Phone (Optional)
              </label>
              <input type="tel" placeholder="+234" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-342" />
            </div>
            <div data-id="element-343">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-344">
                Email Address (Optional)
              </label>
              <input type="email" placeholder="amina@example.com" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-345" />
            </div>
          </div>;
      case 3:
        return <div className="space-y-5" data-id="element-346">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-347">
              Address & Community
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-348">
              Where is your business located?
            </p>

            <div data-id="element-349">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-350">
                Country
              </label>
              <select className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-351">
                <option data-id="element-352">Nigeria</option>
                <option data-id="element-353">Kenya</option>
                <option data-id="element-354">Ghana</option>
              </select>
            </div>
            <div data-id="element-355">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-356">
                State / Region
              </label>
              <input type="text" placeholder="e.g. Kano" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-357" />
            </div>
            <div data-id="element-358">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-359">
                Local Community / Village
              </label>
              <input type="text" placeholder="Enter community name" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-360" />
            </div>
          </div>;
      case 4:
        return <div className="space-y-5 text-center" data-id="element-361">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-362">
              GPS Location
            </h2>
            <p className="text-text-secondary text-sm mb-8" data-id="element-363">
              We need to capture your exact business location for verification.
            </p>

            <div className="w-32 h-32 bg-brand-primary/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-364">
              <MapPin className="w-12 h-12 text-brand-primary" data-id="element-365" />
            </div>

            <Button variant="outline" fullWidth icon={<MapPin className="w-5 h-5" data-id="element-367" />} data-id="element-366">
              Capture Current Location
            </Button>
            <p className="text-xs text-brand-success mt-3 flex items-center justify-center" data-id="element-368">
              <CheckCircle2 className="w-4 h-4 mr-1" data-id="element-369" /> Location captured
              successfully
            </p>
          </div>;
      case 5:
      case 6:
        const isPassport = step === 5;
        return <div className="space-y-5 text-center" data-id="element-370">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-371">
              {isPassport ? 'Upload Passport Photo' : 'Upload National ID'}
            </h2>
            <p className="text-text-secondary text-sm mb-8" data-id="element-372">
              {isPassport ? 'Please provide a clear photo of your face.' : 'Upload a clear picture of your valid government ID.'}
            </p>

            <div className="border-2 border-dashed border-brand-primary/30 rounded-2xl p-8 bg-brand-primary/5 flex flex-col items-center justify-center cursor-pointer hover:bg-brand-primary/10 transition-colors" data-id="element-373">
              <Camera className="w-12 h-12 text-brand-primary mb-4" data-id="element-374" />
              <p className="font-semibold text-brand-primary mb-1" data-id="element-375">
                Tap to take a photo
              </p>
              <p className="text-xs text-text-secondary" data-id="element-376">
                or choose from gallery
              </p>
            </div>
          </div>;
      case 7:
        return <div className="space-y-5" data-id="element-377">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-378">
              Guarantor Details
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-379">
              Provide details of a community leader or trusted person.
            </p>

            <div data-id="element-380">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-381">
                Guarantor Name
              </label>
              <input type="text" placeholder="Full Name" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-382" />
            </div>
            <div data-id="element-383">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-384">
                Relationship
              </label>
              <select className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-385">
                <option data-id="element-386">Community Leader</option>
                <option data-id="element-387">Family Member</option>
                <option data-id="element-388">Business Partner</option>
              </select>
            </div>
            <div data-id="element-389">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-390">
                Phone Number
              </label>
              <input type="tel" placeholder="+234" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-391" />
            </div>
          </div>;
      case 8:
        return <div className="space-y-5" data-id="element-392">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-393">
              Your Skills
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-394">
              Select the skills you currently have.
            </p>

            <div className="flex flex-wrap gap-3" data-id="element-395">
              {['Farming', 'Tailoring', 'Retail', 'Cooking', 'Carpentry', 'Digital Marketing', 'Accounting', 'Weaving'].map((skill, idx) => <button key={idx} className={`px-4 py-2 rounded-xl border-2 text-sm font-semibold transition-colors ${idx < 2 ? 'border-brand-primary bg-brand-primary/10 text-brand-primary' : 'border-gray-200 text-text-secondary hover:border-brand-primary/50'}`} data-id="element-396">
                  {skill}
                </button>)}
            </div>
          </div>;
      case 9:
        return <div className="space-y-5" data-id="element-397">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-398">
              Business Sector
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-399">
              What industry is your business in?
            </p>

            <div className="space-y-3" data-id="element-400">
              {['Agriculture & Farming', 'Retail & Trade', 'Food & Beverage', 'Textiles & Fashion', 'Services'].map((sector, idx) => <label key={idx} className={`flex items-center p-4 rounded-xl border-2 cursor-pointer transition-colors ${idx === 0 ? 'border-brand-primary bg-brand-primary/5' : 'border-gray-200 hover:border-brand-primary/50'}`} data-id="element-401">
                  <input type="radio" name="sector" className="w-5 h-5 text-brand-primary focus:ring-brand-primary" defaultChecked={idx === 0} data-id="element-402" />
                  <span className="ml-3 font-semibold text-text-primary" data-id="element-403">
                    {sector}
                  </span>
                </label>)}
            </div>
          </div>;
      case 10:
        return <div className="space-y-5" data-id="element-404">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-405">
              Business Description
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-406">
              Tell us about what you do.
            </p>

            <div data-id="element-407">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-408">
                Business Name (if any)
              </label>
              <input type="text" placeholder="e.g. Amina's Fresh Produce" className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none" data-id="element-409" />
            </div>
            <div data-id="element-410">
              <label className="block text-sm font-semibold text-text-primary mb-1.5" data-id="element-411">
                Describe your business
              </label>
              <textarea rows={4} placeholder="I sell fresh vegetables in the local market..." className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-brand-primary outline-none resize-none" data-id="element-412"></textarea>
            </div>
          </div>;
      case 11:
        return <div className="space-y-5" data-id="element-413">
            <h2 className="text-2xl font-heading font-bold text-text-primary mb-1" data-id="element-414">
              Support Needs
            </h2>
            <p className="text-text-secondary text-sm mb-6" data-id="element-415">
              What kind of support are you looking for?
            </p>

            <div className="space-y-3" data-id="element-416">
              {[{
              title: 'Financial Support',
              desc: 'Funding for equipment or inventory'
            }, {
              title: 'Training & Education',
              desc: 'Learn new skills to grow'
            }, {
              title: 'Mentorship',
              desc: 'Guidance from experienced business owners'
            }, {
              title: 'Market Access',
              desc: 'Help selling products to more people'
            }].map((need, idx) => <label key={idx} className={`flex items-start p-4 rounded-xl border-2 cursor-pointer transition-colors ${idx < 2 ? 'border-brand-primary bg-brand-primary/5' : 'border-gray-200 hover:border-brand-primary/50'}`} data-id="element-417">
                  <input type="checkbox" className="w-5 h-5 mt-0.5 text-brand-primary focus:ring-brand-primary rounded" defaultChecked={idx < 2} data-id="element-418" />
                  <div className="ml-3" data-id="element-419">
                    <span className="block font-semibold text-text-primary" data-id="element-420">
                      {need.title}
                    </span>
                    <span className="block text-sm text-text-secondary mt-0.5" data-id="element-421">
                      {need.desc}
                    </span>
                  </div>
                </label>)}
            </div>
          </div>;
      case 12:
        return <div className="flex flex-col items-center justify-center text-center py-10 space-y-6" data-id="element-422">
            <div className="w-24 h-24 bg-brand-success/10 rounded-full flex items-center justify-center mb-2" data-id="element-423">
              <CheckCircle2 className="w-12 h-12 text-brand-success" data-id="element-424" />
            </div>
            <div data-id="element-425">
              <h2 className="text-3xl font-heading font-bold text-text-primary mb-2" data-id="element-426">
                Registration Complete!
              </h2>
              <p className="text-text-secondary max-w-[280px] mx-auto" data-id="element-427">
                Your profile has been created successfully. Welcome to the
                FortuneBridge community.
              </p>
            </div>
          </div>;
      default:
        return null;
    }
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-428">
      {step <= totalSteps && <header className="px-4 py-4 flex items-center border-b border-gray-100 sticky top-0 bg-white z-10" data-id="element-429">
          <button onClick={handleBack} className="p-2 -ml-2 text-text-secondary hover:text-text-primary" data-id="element-430">
            <ChevronLeft className="w-6 h-6" data-id="element-431" />
          </button>
          <div className="flex-1 px-4" data-id="element-432">
            <ProgressBar progress={step / totalSteps * 100} heightClass="h-1.5" data-id="element-433" />
          </div>
          <span className="text-xs font-bold text-text-secondary w-8 text-right" data-id="element-434">
            {step}/{totalSteps}
          </span>
        </header>}

      <main className="flex-1 px-6 py-6 overflow-y-auto" data-id="element-435">
        {renderStepContent()}
      </main>

      <div className="p-6 bg-white border-t border-gray-100 shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.05)]" data-id="element-436">
        {step <= totalSteps ? <Button fullWidth size="lg" onClick={handleNext} data-id="element-437">
            {step === totalSteps ? 'Complete Registration' : 'Continue'}
          </Button> : <Button fullWidth size="lg" onClick={() => navigate('/app')} data-id="element-438">
            Go to Dashboard
          </Button>}
      </div>
    </div>;
}